import { render, staticRenderFns } from "./ProposalNotesMessages.vue?vue&type=template&id=cb4ee6fa&"
import script from "./ProposalNotesMessages.vue?vue&type=script&lang=js&"
export * from "./ProposalNotesMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports